export const getPlayerStatus = ({deletedAt, isConcluded, isHeld}: IPlayerAssessment) => {
    return deletedAt ? "Removed" : isConcluded ? "Concluded" : isHeld ? "Held" : ""
}